import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
// import router from '@/router'

Vue.use(Vuex)

// const mainurl = 'http://192.168.1.105:8000';
const mainurl = 'https://appapi.akambc.com';

let state = {
    products: [],
}
const mutations = {
    nothing(){},

    product_list(state , products){
        Vue.set(state, 'products', products);
        Vue.set(state, 'products', [...products]);
    },

    add_product(state, product){
        Vue.set(state, 'products', [...product]);
    },

    edit_product(state, payload){
        const item = state.products.find(item => item.id === payload.id);
        Object.assign(item, payload);
    },

    delete_product(state, id){
        const itemIndex = state.products.findIndex(item => item.id === id);
        state.products.splice(itemIndex , 1);
    },

}
const actions = {
    getProducts({ dispatch, commit }){
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/products`, method: 'GET' })
            .then(res => {
                commit('product_list', res.data.data)
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                  }
                reject(err)
            })
        })
    },

    getProductInfo({ dispatch, commit }, id){
        commit('nothing')
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/product/${id}`, method: 'GET' })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                }
                reject(err)
            })
        })
    },

    addProduct({ dispatch, commit }, payload){
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/storeProduct`, data: payload, method: 'POST' })
            .then(res => {
                commit('add_product', payload)
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                }
                reject(err)
            })
        })
    },

    updateProductInfo({ dispatch, commit }, payload){
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/updateProduct/${payload.id}`, data: payload, method: 'POST' })
            .then(res => {
                commit('edit_product', payload)
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                }
                reject(err)
            })
        })
    },

    deleteProduct({ dispatch, commit }, id){
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/deleteProduct/${id}`, method: 'POST' })
            .then(res => {
                commit('delete_product' , id)
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                }
                reject(err)
            })
        })
    }
}
const modules = {

}
const getters = {
}
export default({
    state,
    mutations,
    actions,
    getters,
    modules,
    axios
})
